export default function TopRightIcon({
  size = 'w-[26px] h-[26px]',
  color = '#2A59C6',
}) {
  return (
    <svg
      className={size}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.53845 19.4602L19.4615 6.53711"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.96155 6.53711H19.4615V17.0371"
        stroke={color}
        strokeWidth="0.807692"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
